/**
 * Custom Tech Radar data source. The stock tech-radar plugin ships a
 * DefaultTechRadarApi that fetches from a tech-radar-backend (not installed) and
 * falls back to sample data. We override `techRadarApiRef` with this client so
 * the radar renders the curated Pyrana dataset instead — no backend required.
 */
import { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';
import { pyranaRadarResponse } from './data';

export class PyranaTechRadarApi implements TechRadarApi {
  async load(_id: string | undefined): Promise<TechRadarLoaderResponse> {
    // Single radar; the id is unused. Data is static + curated in ./data.
    return pyranaRadarResponse;
  }
}
